import { lazy, Suspense, type ComponentType } from "react";
import { Spin } from "antd";
import { useDetailModal } from "@/hooks/useDetailModal";
import type { DetailType } from "@/hooks/useDetailModal";

interface DetailModalProps {
  open: boolean;
  id: number | null;
  onClose: () => void;
}

const IssueDetailModal = lazy(() =>
  import("./IssueDetailModal").then((m) => ({ default: m.IssueDetailModal })),
);
const CustomerDetailModal = lazy(() =>
  import("./CustomerDetailModal").then((m) => ({
    default: m.CustomerDetailModal,
  })),
);
const ProductDetailModal = lazy(() =>
  import("./ProductDetailModal").then((m) => ({
    default: m.ProductDetailModal,
  })),
);
const ProjectDetailModal = lazy(() =>
  import("./ProjectDetailModal").then((m) => ({
    default: m.ProjectDetailModal,
  })),
);
const FeatureDetailModal = lazy(() =>
  import("./FeatureDetailModal").then((m) => ({
    default: m.FeatureDetailModal,
  })),
);
const ActivationDetailModal = lazy(() =>
  import("./ActivationDetailModal").then((m) => ({
    default: m.ActivationDetailModal,
  })),
);
const InstallationDetailModal = lazy(() =>
  import("./InstallationDetailModal").then((m) => ({
    default: m.InstallationDetailModal,
  })),
);

const modalMap: Record<
  Exclude<DetailType, "">,
  ComponentType<DetailModalProps>
> = {
  issue: IssueDetailModal,
  customer: CustomerDetailModal,
  product: ProductDetailModal,
  project: ProjectDetailModal,
  feature: FeatureDetailModal,
  activation: ActivationDetailModal,
  installation: InstallationDetailModal,
};

export function DetailModalManager() {
  const { visible, type, id, closeDetail } = useDetailModal();

  if (!type) return null;

  const ModalComponent = modalMap[type];
  if (!ModalComponent) return null;

  return (
    <Suspense fallback={<Spin />}>
      <ModalComponent open={visible} id={id} onClose={closeDetail} />
    </Suspense>
  );
}
